import styled, { keyframes } from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 230px;
  background-color: #f4f4f4;
  overflow-x: hidden;
  @media (max-width: 1199px) {
    .icon {
      right: 10%;
    }
  }
  @media (max-width: 991px) {
    padding: 42px;
  }
  @media (max-width: 767px) {
    padding: 12px;
  }
`;

export const Section = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const TextWrapper = styled.div`
  flex: 1;
  text-align: left;

  @media (max-width: 767px) {
    text-align: center;
  }
`;

// h3 스타일
export const Heading = styled.h3`
  font-size: 34px;
  margin-bottom: 20px;
  min-width: 250px;

  span {
    color: #3bb77e;
  }
  @media (max-width: 991px) {
    font-size: 24px;
  }
  @media (max-width: 767px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
`;

export const SubscibeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubscibeWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  gap: 30px;

  @media (max-width: 767px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const SubscibeInput = styled.input`
   {
    flex: 1;
    height: 50px;
    border: none;
    outline: none;
    padding: 0 12px;
    font-size: 16px;
    background-color: white;
       
    @media (max-width: 767px) {
    padding: 10px 12px;
    width: 100%;
    margin-bottom: 15px;
  }
       
   @media (max-width: 575px) {
   padding: 10px 12px;
   width: 100%;
   margin-bottom: 15px;
   }
`;

export const SubscibeButton = styled.button`{
    height: 50px;
    padding: 0 16px;
    border: none;
    border-radius: 10px;
    background-color: #3bb77e;
    color: white;
    font-size: 16px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background-color: #349b6c;
    }

    @media (max-width: 767px) {
        width: 100%;
    }
`;

// Paragraph 스타일
export const Paragraph = styled.p`
  font-size: 14px;
  color: #666;
  margin-top: 10px;

  @media (max-width: 767px) {
    font-size: 13px;
  }
`;

// Link 스타일
export const StyledLink = styled.a`
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  color: #3bb77e;
  margin-top: 10px;

  &:hover {
    color: #349b6c;
  }

  @media (max-width: 767px) {
    font-size: 13px;
  }
`;
